import TpCheckboxBase from '../checkbox/tp-checkbox-base.js';
import SelectionBaseMixin from './tp-selection-base-mixin.js';
import HelperTextMixin from '../../mixins/helper-text-mixin.js';
import { internal } from '../../../vendor/elix.js';

class TpSelectionCheckbox extends HelperTextMixin(SelectionBaseMixin(TpCheckboxBase)) {

  get [internal.template]() {
    const template = super[internal.template];
    const helperText = template.content.querySelector('.helpertext');
    template.content.querySelector('.wrapper').append(helperText);
    return template;
  }

}

export default TpSelectionCheckbox;
